import { createContext, useContext, useMemo, useState } from "react";

function useSeedFactory() {
  const [traffic, setTraffic] = useState(null)

  return useMemo(() => ({
    traffic, setTraffic,
  }), [traffic])
}

const Context = createContext({})
const useSeed = () => useContext(Context)

const SeedProvider = ({ children }) => {
  const value = useSeedFactory()

  return <Context.Provider value={value}>
    {children}
  </Context.Provider>
}

export {
  useSeed,
  SeedProvider,
}
